// extracted by mini-css-extract-plugin
export default {"root":"PlaceholderListContainer-root_YgSXT"};